import * as React from 'react';
import { ArtifactAcceptability, SvcResults, SvcTestResults } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import ResultsGroupHeading from '../Shared/ResultsGroupHeading';

export interface QualityAcceptabilityTableProps {
    results: SvcResults;
}

interface QualityRowProps {
    title: string;
    artifact: (tr: SvcTestResults) => ArtifactAcceptability;
}

export const SvcQualityAcceptabilityTable = ({ results }: QualityAcceptabilityTableProps) => {
    const QualityAcceptability = (artifact) => {
        switch (artifact) {
            case ArtifactAcceptability.Undetermined:
                return <i aria-hidden="true" title="Undetermined">-</i>
            case ArtifactAcceptability.Acceptable:
                return <i className="fas fa-check text-success" aria-hidden="true" title="Acceptable"></i>
            case ArtifactAcceptability.Usable:
                return <i className="far fa-circle text-warning" aria-hidden="true" title="Usable"></i>
            case ArtifactAcceptability.NotAcceptable:
                return <i className="fas fa-times text-danger" aria-hidden="true" title="Not Acceptable"></i>
        }
    }

    const QualityRow = ({ title, artifact }: QualityRowProps) => {
        return (
            <tr>
                <td>
                    {title}
                </td>
                {results.TestResults.map((tr) => {
                    return (
                        <td key={`Quality${tr.TestId}`}>
                            {artifact(tr) !== null && artifact(tr) !== undefined ? QualityAcceptability(artifact(tr)) : "-"}
                        </td>
                    );
                })}
                <td></td>
            </tr>
        );
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Acceptability" />
            <QualityRow title="Flow Plateau" artifact={(tr) => tr.FlowPlateauQuality} />
        </>
    );
}

